import React from "react";
import "date-fns";

import GeneralIndicators from "../../components/Indicators/General/general";

export default function IndicatorsByPublisher(props) {  
  return (
    <>
      <GeneralIndicators publishers={[localStorage.getItem('publisher-active')]} siteId={""}></GeneralIndicators>
    </>
  );
}